module.exports = __webpack_public_path__ + "static/collaborators-48e2374573e8e5f42efe338353bf79c3.svg";